import React, { type FC } from 'react';
import { customTwMerge } from '/react4xp/util/customTwMerge';
import { type AsProps, Element } from './Element';




export const Ul: FC<AsProps> = ({
	className,
	...otherProps
}) => <Element
	{...otherProps}
	as='ul'
	className={customTwMerge('m-0 p-0', className)}
/>;


export const Ol: FC<AsProps> = ({
	className,
	...otherProps
}) => <Element
	{...otherProps}
	as='ol'
	className={customTwMerge('m-0 p-0', className)}
/>;

export const Li: FC<AsProps> = (props) => <Element {...props} as='li'/>;
